let cursor = document.querySelector("#cursor");

let headers = document.querySelector(".banner");

if (headers) {
	headers.addEventListener("mouseenter", (e) => {
		cursor.classList.add("pale-green");
	});

	headers.addEventListener("mouseleave", (e) => {
		cursor.classList.remove("pale-green");
	});
}
